import { render, staticRenderFns } from "./BankAccountEdit.vue?vue&type=template&id=57b50c00&scoped=true"
import script from "./BankAccountEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankAccountEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/css/scoped/expansion-container-style.css?vue&type=style&index=0&id=57b50c00&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b50c00",
  null
  
)

/* custom blocks */
import block0 from "@/assets/locales/i18n-bank-account-edit.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FBankAccountEdit.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/assets/locales/i18n-validations.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FBankAccountEdit.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports